<template>
  <b-form-checkbox
      id="checkbox-1"
      v-model="prop.value"
      :disabled="prop.readonly"
      switch
  ></b-form-checkbox>
</template>
<script>
export default {
  name: 'CheckBoxInput',
  props: {
    prop: {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editor/CheckBoxInput.vue